import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {
  coreAnalyticsEvents,
  CoreUtilsService,
  resolvePickerLocale
} from '@bepatient/core';

@Component({
  selector: 'bepatient-onboarding-input-text',
  templateUrl: './onboarding-input-text.component.html',
  styleUrls: ['./onboarding-input-text.component.scss'],
  standalone: false
})
export class OnboardingInputTextComponent implements OnInit {
  private element = inject(ElementRef);
  private utils = inject(CoreUtilsService);

  _color;
  @Input() type;
  @Input() colorsSwitcher = false;
  @Input() placeholder: string;
  @Input() bpFormGroup: UntypedFormGroup;
  @Input() bpFormControlName: UntypedFormControl;
  @Input() bpFormControlMaxLength: number;
  @Input() bpFormControlMinLength: number;
  @Input() birthdateFormat: 'YYYY' | 'YYYY-MM' | 'MM-YYYY';
  @Input() dateFormat?: string;
  @Input() pickerFormat?: string;
  @Input() constraints: {};
  @Input() set language(value: string | null | undefined) {
    this.userLocale = resolvePickerLocale(value);
  }

  @Input() biometricType: string | null; // 'face', 'finger', or null

  @Output() ionChange = new EventEmitter<CustomEvent>();
  @Output() isFocused = new EventEmitter<boolean>();
  @Output() biometricClick = new EventEmitter<void>();

  passwordIcon: 'eye' | 'eye-off' = 'eye';
  passwordType: 'text' | 'password' = 'password';
  pickerCurrentDate: string;
  userLocale: string;
  pickerType: string = 'month-year';

  @Input() set color(color: string) {
    this._color = color;
    this.element.nativeElement.style.setProperty('--font-color', color);
  }

  get color() {
    return this._color;
  }

  constructor() {
    this.pickerCurrentDate = '';
    // fix
    const stored = localStorage.getItem('locale');
    const zhCn = resolvePickerLocale('zh');
    const zhTw = resolvePickerLocale('tw');
    this.userLocale =
      (stored === zhCn || stored === zhTw ? zhCn : stored) ??
      resolvePickerLocale('en');
  }

  ngOnInit(): void {
    if (this.birthdateFormat) {
      let parseToFormat = this.birthdateFormat.toLowerCase();
      this.pickerType =
        this.utils.getValidDateFormat(parseToFormat)?.pickerType ||
        'month-year';
    }
  }

  onBiometricClick(event: Event): void {
    event.stopPropagation();
    const active = document.activeElement as HTMLElement | null;
    if (active && typeof active.blur === 'function') {
      active.blur();
    }
    this.biometricClick.emit();
  }

  switchPassword(): void {
    this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
    this.passwordIcon = this.passwordIcon === 'eye-off' ? 'eye' : 'eye-off';
  }
  onFocus(): void {
    this.isFocused.emit(true);
  }

  getMax(constraints: any[]) {
    return constraints && constraints['max']
      ? constraints['max']
      : this.getDefaultYear();
  }

  getMin(constraints: any[]) {
    return constraints && constraints['min'] ? constraints['min'] : '1900';
  }

  onBlur(): void {
    this.isFocused.emit(false);
  }

  private getDefaultYear(years = 50): string {
    return (new Date().getFullYear() + years).toString();
  }

  onDateChange(dateString) {
    if (dateString) {
      let parseToFormat = this.birthdateFormat.toLowerCase();
      let { userFormat, isoFormat } = this.utils.getValidDateFormat(
        parseToFormat,
        dateString
      );

      this.bpFormControlName.patchValue(userFormat || void 0);
      this.pickerCurrentDate = dateString;
    } else {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      let defaultDate = `${year}-${month}`;
      let parseToFormat = this.birthdateFormat.toLowerCase();
      let { userFormat, isoFormat } = this.utils.getValidDateFormat(
        parseToFormat,
        defaultDate
      );

      this.pickerCurrentDate = defaultDate; // Format as 'YYYY-MM'
      this.bpFormControlName.patchValue(userFormat || void 0);
    }
  }
}
